import React from "react";
import { Typography, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";

type AppInfoBannerProps = {
  children: React.ReactNode;
};

/**
 * Bandeau informatif avec contrastes renforcés en mode sombre
 * (fond plus sombre + texte blanc + accent secondaire).
 */
export const AppInfoBanner: React.FC<AppInfoBannerProps> = ({ children }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Typography
      variant="body1"
      component="div"
      sx={{
        width: "100%",
        textAlign: "center",
        p: 2,
        borderRadius: 1,
        borderLeft: isDark ? `4px solid ${theme.palette.secondary.main}` : 0,
        bgcolor: isDark
          ? alpha(theme.palette.primary.dark, 0.92)
          : theme.palette.secondary.main,
        color: isDark ? "#ffffff" : theme.palette.text.primary,
        boxShadow: isDark
          ? `inset 0 0 0 1px ${alpha("#ffffff", 0.14)}`
          : undefined,
      }}
    >
      {children}
    </Typography>
  );
};
